import {Modal} from 'antd'

// Dùng chung cho CẢ FamilyBookCard (list, WorkspaceFamilyBook.js) lẫn ParishBookReviewDrawer (chi
// tiết) - tách file riêng (không khai trong WorkspaceFamilyBook.js) để tránh import vòng (2 file đó
// đã import lẫn nhau: WorkspaceFamilyBook.js -> ParishBookReviewDrawer.js).
//
// MỞ khoá luôn phải qua Modal.confirm (chiều rủi ro - mở quyền sửa bí tích cho chủ sổ, kẻo nhấp
// nhầm mất luôn ý nghĩa "đã đối chiếu"); KHOÁ lại thì gọi thẳng (chiều an toàn, không cần hỏi lại) -
// đúng yêu cầu "unlock bí tích phải có xác nhận lại, kẻo nhấp nhầm".
export const confirmToggleSacramentsLock = (item, onToggleLock, t) => {
    if (!item.sacraments_locked) {
        onToggleLock(item.id, true)
        return
    }
    Modal.confirm({
        rootClassName: 'family-theme',
        title: t('unlock sacraments confirm title'),
        content: t('unlock sacraments confirm text'),
        // 2 nút full-width xếp chồng, CÙNG convention đã dùng ở PollEmbed.js (Modal.confirm cho hành
        // động cần xác nhận rõ - size=large + block + rounded-xl, cancel dạng "text" mờ hơn) thay vì
        // để mặc định antd (Huỷ nhỏ nằm phải, OK tự co theo nội dung, lệch cân đối). okText NGUYÊN
        // câu dài (dùng lại đúng string t('unlock sacraments hint') - cũng là tooltip icon khoá ở
        // FamilyBookCard/ParishBookReviewDrawer, không tách text ngắn riêng cho nút) nên vẫn phải
        // cho wrap nhiều dòng (whitespace-normal - mặc định antd Button nowrap khiến chữ tràn khung,
        // bug thực tế đã gặp), không cắt ngắn câu.
        okText: t('unlock sacraments hint'),
        okButtonProps: {
            size: 'large',
            danger: true,
            block: true,
            className: 'rounded-xl no-shadow no-text-shadow no-border font-semibold whitespace-normal h-auto py-2 leading-snug',
        },
        cancelText: t('cancel'),
        cancelButtonProps: {
            size: 'large',
            type: 'text',
            block: true,
            className: 'rounded-xl no-shadow no-text-shadow no-border font-medium text-color-400',
        },
        onOk: () => onToggleLock(item.id, false),
    })
}
